import React, { Fragment } from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import Loader from 'components/LayoutComponents/Loader'
import PublicLayout from './Public'
import LoginLayout from './Login'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  login: LoginLayout,
  main: MainLayout,
}

@withRouter
@connect(({ user }) => ({ user }))
class IndexLayout extends React.PureComponent {
  previousPath = ''

  componentDidUpdate(prevProps) {
    const { location } = this.props
    const { prevLocation } = prevProps
    if (location !== prevLocation) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      children,
      location: { pathname, search },
      user,
    } = this.props


    // NProgress Management
    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      NProgress.start()
    }

    setTimeout(() => {
      NProgress.done()
      this.previousPath = currentPath
    }, 300)

    // Layout Rendering
    const getLayout = () => {
      if (pathname === '/') {
        return 'public'
      }
      if (/^\/user(?=\/|$)/i.test(pathname)) {
        return 'login'
      }
      return 'main'
    }

    const Container = Layouts[getLayout()]
    const isUserAuthorized = user.authorized
    const isUserLoading = user.loading
    const isLoginLayout = getLayout() === 'login'
    const BootstrappedLayout = () => {
      // show loader when user in check authorization process, not authorized yet and not on login pages
      if (isUserLoading && !isUserAuthorized && !isLoginLayout) {
        return <Loader />
      }
      // redirect to login page if current is not login page and user not authorized
      if (!isLoginLayout && !isUserAuthorized) {
        
        const {location} = this.props
        const urlPDF = location.pathname.substr(1,6)
        if (location.pathname !== "/Activations/bogota" && location.pathname !== "/Activations/medellin" && urlPDF !== "Downlo" && urlPDF !== "reset/") {
          return <Redirect to="/user/login" />
        }
      }
      // redirect to main dashboard when user on login page and authorized
      if (isLoginLayout && isUserAuthorized) {

        const roleUser =  JSON.parse(localStorage.getItem('userData')).role
        
        switch (roleUser) {
          case 'ADMIN':
          case 'MANAGER':
          case 'SUPERADMIN':
            return <Redirect to="/admin/dashboardQuqo" />
          case 'SUPERVISOR':
            return <Redirect to="/admin/dashboardQuqo" />
          case 'RETAILER':
              return <Redirect to="/admin/ordersRetailers" />
          case 'STORAGE':
            return <Redirect to="/admin/ordersRetailers" />
          case 'STORE':
            return <Redirect to="/admin/dashboardQuqo" />
          case 'SUPPORT':
            return <Redirect to="/admin/promotions" />
          default:
            break
        }
      }
      // in other case render previously set layout
      return <Container>{children}</Container>
    }

    return (
      <Fragment>
        <Helmet titleTemplate="Admin | %s" title="Quqo" />
        {BootstrappedLayout()}
      </Fragment>
    )
  }
}

export default IndexLayout
